export enum NoteType {
    Note,
    List
}